import { AxiosError } from "axios";
import { createMutation } from "react-query-kit";

import { Charge } from "./GetCharge";
import { privateApi, ErrorResponse } from "api";

export type VoidChargeResult = Charge | null;
export type VoidChargeParams = {
    id: string;
    reason?: string | null;
};

async function voidCharge({ id, ...params }: VoidChargeParams): Promise<VoidChargeResult> {
    // ensure charge id was provided
    if (!id) {
        throw new TypeError('Id is a required parameter');
    }

    // make api call
    const result = await privateApi.patch<VoidChargeResult>(`${import.meta.env.VITE_API_BASE_URL}/finance/charges/${id}/void`, params);

    // return the data object
    return result.data;
}

const useVoidCharge = createMutation<VoidChargeResult, VoidChargeParams, AxiosError<ErrorResponse>>({
    mutationFn: async (variables: VoidChargeParams) => voidCharge(variables),
});

export { voidCharge, useVoidCharge };
